import React from 'react';
import { Stack } from '@atlaskit/primitives';
import { FormattedMessage } from '@atlassian/jira-intl';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { Link } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import { GenericEmptyState } from '../../../../../common/ui/generic-empty-state/index.tsx';
import { DOCUMENTATION_LINK } from '../constants.tsx';
import messages from './messages.tsx';
import type { EmptyStateProps } from './types.tsx';

export const ConfigEmptyState = ({ link }: EmptyStateProps) => {
	const isJiraAdmin = useIsAdmin();

	return (
		<GenericEmptyState
			header={
				fg('itsm-issue-renaming') ? (
					<FormattedMessage
						{...(isJiraAdmin
							? messages.headerIssueTermRefresh
							: messages.headerNotJiraAdminIssueTermRefresh)}
					/>
				) : (
					<FormattedMessage {...(isJiraAdmin ? messages.header : messages.headerNotJiraAdmin)} />
				)
			}
			description={
				<Stack>
					<FormattedMessage
						{...(fg('itsm-issue-renaming')
							? messages.descriptionIssueTermRefresh
							: messages.description)}
					/>
					<Link href={DOCUMENTATION_LINK} target="_blank">
						<FormattedMessage
							{...(fg('itsm-issue-renaming')
								? messages.readMoreAboutIssueSecurityIssueTermRefresh
								: messages.readMoreAboutIssueSecurity)}
						/>
					</Link>
				</Stack>
			}
			link={link}
		/>
	);
};
